import {
  selectCurrency,
  selectFinancialYear,
  selectPartnerId,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { selectJBPSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { P360Currency } from 'partner360/models/P360Currency'

import { getMdfPlannedFunds } from '../lib/getMdfPlannedFunds'
import { getMdfOverviewMetrics } from '../ui/mdfAggregatedOverview/helpers/getMdfOverviewMetrics'

import { useMdfAnalysis } from './useMdfAnalysis'
import { useMdfContraMetrics } from './useMdfContraMetrics'
import { useMdfDashboardFiltersForm } from './useMdfDashboardFiltersForm'

export const useMdfOverviewMetrics = () => {
  const partnerId = useSelector(selectPartnerId)
  const fYear = useSelector(selectFinancialYear)
  const programType = useSelector(selectProgramType)
  const { kiBusinessPriorities } = useSelector(selectJBPSettings)
  const { filteredActivities: activities, initiatives } = useMdfAnalysis(partnerId)
  const activeCurrency = useSelector(selectCurrency)
  const { strategicInitiativesFilterValue, businessPrioritiesFilterValue, timeframesFilterValue } =
    useMdfDashboardFiltersForm()

  const isUsd = activeCurrency === P360Currency.USD

  const metrics = useMemo(() => getMdfOverviewMetrics(activities, isUsd), [activities, isUsd])
  const totalPlanned = useMemo(
    () =>
      getMdfPlannedFunds(initiatives, kiBusinessPriorities, {
        partnerId,
        fYear,
        programType,
        isUsd,
        strategicInitiatives: strategicInitiativesFilterValue ?? [],
        businessPriorities: businessPrioritiesFilterValue ?? [],
        timeframes: timeframesFilterValue ?? [],
      }),
    [
      initiatives,
      kiBusinessPriorities,
      partnerId,
      fYear,
      programType,
      isUsd,
      strategicInitiativesFilterValue,
      businessPrioritiesFilterValue,
      timeframesFilterValue,
    ]
  )
  const contraMetrics = useMdfContraMetrics(partnerId, activities)

  return { metrics, totalPlanned, contraMetrics, isUsd, activeCurrency }
}
